import React from 'react';
import { createPortal } from 'react-dom';
import { Stack } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { useNotifications } from 'store/layout/hooks/useNotifications';
import { INotification } from 'store/layout/layoutState';

import { snackbarBottomSpacing, snackbarZIndex } from '../Snackbar';

import { GlobalToast } from './GlobalToast';

export const GlobalToasts = () => {
  const { toasts } = useNotifications();

  const wrapperId = useId();

  const renderToast = React.useCallback((toast: INotification, index: number) => {
    return <GlobalToast key={`${toast.id}_${index}`} toast={toast} />;
  }, []);

  const tokens = {
    childrenGap: 16,
  };

  if (toasts.length > 0) {
    return createPortal(
      <div
        id={wrapperId}
        style={{
          position: 'absolute',
          bottom: snackbarBottomSpacing,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: snackbarZIndex,
        }}
      >
        <Stack tokens={tokens} disableShrink>
          {toasts.map(renderToast)}
        </Stack>
      </div>,
      document.body
    );
  }

  return null;
};
